import React, {useState} from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import '../../../assets/css/app.css'; 

const Progress  = ({active_step}) => {


  const steps = [
      'Choose Plan', 
      'Get Profile', 
      'Enter Email',
      'Verify Email',
      'Get Domain',
      'Confirmation'
  ];

  return (
  <div className='border-bottom border-width-1 mb-2'>
    <Nav className="justify-content-center stepper-horizontal">
      {steps.map((label, index) => (
        <NavItem key={label} className={`step-item ${index === active_step ? 'active' : 'text-muted'}`}>
           <div className='py-1 px-3 ms-2'>
                <h6 className='fw-normal'>{label}</h6>
                <div className='d-flex align-items-center justify-content-center'><span className='step-circle'>{index + 1}</span></div>
              
           </div>
        </NavItem>
      ))}
    </Nav>
      </div>
  )
}

export default Progress;
